/*
 * @format
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdditionalLinks from './AdditionalLinks'

import {LaunchDarklyProvider, FeatureFlag} from '../LaunchDarkly';
import RentalsPromoBlock from '../GearRentalPromos/RentalsPromoBlock'

export default class RightRail extends Component {
    static propTypes = {
        assetId: PropTypes.string,
        rightRail: PropTypes.shape({
            title: PropTypes.string,
            body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            links: PropTypes.arrayOf(PropTypes.any),
            notAuth: PropTypes.bool,
            showRentalPromo: PropTypes.bool,
        })
    }

    render() {
        if (!this.props.rightRail) {
            return null;
        }

        const {
            title = '',
            body = null,
            links,
            notAuth,
            showRentalPromo = true
        } = this.props.rightRail;

        // Exclude these permit locations
        const excludedList = ['233396', '251349', '249991', '233304', '233328']

        const unAuthClassName = notAuth ? "rec-aside-unauth" : "";
        return (
            <div className="rec-venue-page-right-rail">
                <aside>
                    <div className={`rec-aside-header ${unAuthClassName}`}>
                        <div>{title}</div>
                    </div>
                    <div className="rec-aside-body">
                        {body}
                    </div>

                    <AdditionalLinks links={links} />
 
                    {/* Gear Rental Promo */}
                    {showRentalPromo && (
                        <LaunchDarklyProvider>
                            <FeatureFlag flag="gearRentalPermitsPromo">
                                {!excludedList.includes(this.props.assetId) && (
                                    <RentalsPromoBlock
                                        className="mt-3"
                                        copy="Learn more about gear and RV rental options for your trip."
                                    />)
                                }
                            </FeatureFlag>
                        </LaunchDarklyProvider>
                    )}
                </aside>
            </div>
        );
    }
}